import { FC } from 'react'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Layout from 'components/layout/Layout'
import Pricing from 'features/pricing/Pricing'

const PricingPage: FC = (props) => {
  return (
    <Layout>
      <Pricing {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale))
    }
  }
}

export default PricingPage
